<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-add-bookshelf`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4h32c-1.333 2.667-2 5.333-2 8s.667 5.333 2 8H12a8 8 0 110-16zm32 28a8 8 0 00-8-8H4l.228.47C5.41 26.98 6 29.49 6 32l-.007.47C5.92 34.98 5.255 37.49 4 40h10v-4.001L9.6 36l.105-.569A20.201 20.201 0 009.6 28H36l.2.005A4 4 0 0140 32l-.005.2A4 4 0 0136 36l-2-.001V40h2l.25-.004A8 8 0 0044 32zm-11.858 2.121a1 1 0 000-1.414l-1.414-1.414a1 1 0 00-1.414 0l-6.365 6.363-2.828-2.828a1 1 0 00-1.414 0l-1.414 1.415a1 1 0 000 1.414l4.95 4.95c.18.18.412.277.648.29h.118l.117-.013a.996.996 0 00.53-.277l1.415-1.415.007-.006 7.064-7.065zM12 8h26.4c-.266 1.327-.4 2.66-.4 4 0 1.34.134 2.673.4 4H12a4 4 0 010-8z"/></svg>
</template>
<script>

export default {
  name: 'IconAddBookshelf',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
